'use client';

import { Box, Container, Typography, Grid, Stepper, Step, StepLabel, StepContent, Paper } from '@mui/material';
import { dronesData } from '@/data/proyectos/drones/dronesData';
import TimelineIcon from '@mui/icons-material/Timeline';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssessmentIcon from '@mui/icons-material/Assessment';

const icons = [TimelineIcon, CloudUploadIcon, AnalyticsIcon, AssessmentIcon];

export default function ScientificWorkflow() {
  return (
    <Box sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Typography variant="h3" fontWeight={700} mb={2}>
            Metodología Científica
          </Typography>
          <Typography variant="h6" color="text.secondary" maxWidth="800px" mx="auto">
            Flujo de trabajo estructurado para investigación reproducible
          </Typography>
        </Box>

        <Stepper orientation="vertical" sx={{ position: 'relative' }}>
          {dronesData.workflow.steps.map((step, index) => {
            const IconComponent = icons[index];
            return (
              <Step key={step.step} active={true} sx={{ mb: 6 }}>
                <StepLabel
                  StepIconComponent={() => (
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '1.5rem'
                      }}
                    >
                      {step.step}
                    </Box>
                  )}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <IconComponent sx={{ mr: 2, color: 'primary.main' }} />
                    <Typography variant="h5" fontWeight={600}>
                      {step.title}
                    </Typography>
                  </Box>
                </StepLabel>
                
                <StepContent>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 4,
                      ml: 3,
                      borderRadius: 3,
                      bgcolor: '#f8fafc',
                      border: '1px solid #e2e8f0'
                    }}
                  >
                    <Typography variant="body1" paragraph>
                      {step.description}
                    </Typography>
                    
                    <Typography variant="subtitle1" fontWeight={600} mb={2}>
                      Herramientas utilizadas:
                    </Typography>
                    
                    <Grid container spacing={2}>
                      {step.tools.map((tool, idx) => (
                        <Grid key={idx} size={{ xs: 12, sm: 6, md: 4 }}>
                          <Box
                            sx={{
                              p: 2,
                              bgcolor: 'white',
                              borderRadius: 2,
                              border: '1px solid #e2e8f0',
                              textAlign: 'center'
                            }}
                          >
                            <Typography variant="body2">{tool}</Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
      </Container>
    </Box>
  );
}